import { render } from "./AppiointmentThisWeek.vue?vue&type=template&id=81719f38"
import script from "./AppiointmentThisWeek.vue?vue&type=script&lang=js"
export * from "./AppiointmentThisWeek.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__